import { stickyHeaderHeadroom } from '@/shared/instances/sticky-header';

const lockedScrollYAttribute = 'data-scroll-locked-y';

const headerSelector = '.js-sticky-header-wrapper';
const headerScrollLockClasses = ['fixed', 'w-full'];

const bodyScrollLockClasses = ['fixed', 'w-full'];
const mainScrollLockClasses = ['relative'];

const calculateMainOffset = (): number => {
  const fullHeader = document.querySelector<HTMLElement>('header');
  const banner = fullHeader?.previousElementSibling as HTMLElement;
  const scrollPadding = 20;

  return (
    (fullHeader?.offsetHeight || 0) +
    (banner?.offsetHeight || 0) -
    scrollPadding
  );
};

export const lockBodyScroll = () => {
  const body = document.body;
  const stickyHeader = document.querySelector<HTMLElement>(headerSelector);
  const main = document.querySelector<HTMLElement>('main');
  const mainOffset = calculateMainOffset();

  const scrollY = window.scrollY;
  body.setAttribute(lockedScrollYAttribute, String(scrollY));

  stickyHeaderHeadroom?.freeze();
  stickyHeader?.classList.add(...headerScrollLockClasses);
  main?.classList.add(...mainScrollLockClasses);

  // Apply dynamic top offset as inline style
  if (main) {
    main.style.top = `${mainOffset}px`;
  }

  body.style.top = `-${scrollY}px`;
  body.classList.add(...bodyScrollLockClasses);
};

export const unlockBodyScroll = async () => {
  const body = document.body;
  const stickyHeader = document.querySelector<HTMLElement>(headerSelector);
  const main = document.querySelector<HTMLElement>('main');

  const scrollY = parseInt(body.getAttribute(lockedScrollYAttribute) || '0');
  body.removeAttribute(lockedScrollYAttribute);

  body.classList.remove(...bodyScrollLockClasses);
  if (body.classList.length === 0) {
    body.removeAttribute('class');
  }

  body.style.top = '';
  if (!body.getAttribute('style')) {
    body.removeAttribute('style');
  }

  window.scrollTo({ top: scrollY });

  main?.classList.remove(...mainScrollLockClasses);
  if (main) {
    main.style.top = '';
  }

  if (!main?.getAttribute('style')) {
    main?.removeAttribute('style');
  }
  if (main?.classList.length === 0) {
    main.removeAttribute('class');
  }

  stickyHeader?.classList.remove(...headerScrollLockClasses);
  if (stickyHeader?.classList.length === 0) {
    stickyHeader.removeAttribute('class');
  }

  // wait one tick before unfreezing to maintain header position
  setTimeout(() => stickyHeaderHeadroom?.unfreeze());
};
